<template>
	<details ref="detailsElement" :open="defaultOpen">
		<summary class="title">
			<span class="title-text">{{ title }}</span>
			<span class="title-icon"><IconSvg icon="caret-down" /></span>
		</summary>
		<div class="content">
			<slot></slot>
		</div>
	</details>
</template>
<script lang="ts" setup>
	import {ref} from 'vue';
	import IconSvg from '~/components/generic/IconSvg.vue';

	defineProps({
		title: {
			type: String,
			required: true
		},
		defaultOpen: {
			type: Boolean,
			default: false
		}
	});

	const detailsElement = ref<HTMLDetailsElement | null>(null);

	const open = () => {
		detailsElement.value?.setAttribute('open', 'open');
	};

	const close = () => {
		detailsElement.value?.removeAttribute('open');
	};

	defineExpose({open, close});
</script>

<style scoped>
	details {
		--title-color: var(--details-title-color, var(--color-primary));
		--title-icon-size: var(--details-title-icon-size, 1.5em);
		--title-font-size: var(--details-title-font-size, 1em);
		--title-line-height: var(--details-title-line-height, inherit);
		--title-font-weight: var(--details-title-font-weight, normal);
	}

	summary {
		list-style: none;
		user-select: none;
	}

	summary::-webkit-details-marker {
		display: none;
	}

	details[open] .title-icon {
		transform: scale(-1);
	}

	.title {
		display: flex;
		align-items: flex-start;
		gap: 8px;
		cursor: pointer;
		color: var(--title-color);
		font-size: var(--title-font-size);
		line-height: var(--title-line-height);
		font-weight: var(--title-font-weight);
	}

	.title-text {
		flex: 0 1 auto;
	}

	.title-icon {
		flex: 0 0 auto;
		--icon-size: var(--title-icon-size);
	}

	.content {
		margin-top: 10px;
	}
</style>
